import React, { ReactElement } from 'react';
import TabHeader from '../../../../components/Tabs/TabHeader';
import {
  FilterOutlined,
  InfoOutlined,
  UnorderedListOutlined
} from '@ant-design/icons';
import { Typography } from 'antd';
import Tabs from '../../../../components/Tabs/Tabs';
import TabPane from '../../../../components/Tabs/TabPane';
import HelpTab from './HelpTab';
import ToolsTab, { ToolsTabIcon } from '../../../../components/Tabs/ToolsTab';
import ObservationFilters from './ObservationFilters';
import ShareTab, { ShareTabIcon } from '../../../../components/Tabs/ShareTab';
import HiddenClashes from './HiddenClashes';
import { Trans, useTranslation } from 'react-i18next';

const tabHeaders: ReactElement[] = [
  <TabHeader step={0} key={0}><InfoOutlined /></TabHeader>,
  <TabHeader step={1} key={1}><FilterOutlined /></TabHeader>,
  <TabHeader step={2} key={2}><UnorderedListOutlined /></TabHeader>,
  <TabHeader step={3} key={3}><ToolsTabIcon /></TabHeader>,
  <TabHeader step={4} key={4}><ShareTabIcon /></TabHeader>
];

export default function ObservationsSidePanel() {
  const { t } = useTranslation("observations", { useSuspense: true });

  return (
    <>
      <Typography.Title level={3}>{t("lajihavainnotOtsikko")}</Typography.Title>
      <p>
        <span>{t("ekaRivi")}</span>
      </p>
      <p>
        <span>{t("tokaRivi")}</span>
      </p>
      <p>
        <span>
          <Trans i18nKey="observations:kolmasRivi" components={{
            FilterOutlined: <FilterOutlined />,
          }}>
            Voit valita, mitä lajihavaintoja ja/tai metsänkäyttöilmoituksia kartalla näytetään suodatinvalinnan kautta (kohta <FilterOutlined /> valikossa).
          </Trans>
        </span>
      </p>
      <p>
        {t("neljäsRivi")}
      </p>

      <p>
        <Trans i18nKey={"observations:viidesRivi"} components={{
          i: <i className="esri-icon-layers" />
        }}>
          Jokaisen karttatason läpinäkyvyyttä voi säätää erikseen kartan oikean alanurkan <i className="esri-icon-layers" />-napin takaa klikkaamalla tason kohdalla kolmea pistettä.
        </Trans>
      </p>

      <Tabs tabHeaders={tabHeaders}>
        <TabPane number={0}>
          <HelpTab />
        </TabPane>
        <TabPane number={1}>
          <>
            <Typography.Title level={4}>{t("suodattimetOtsikko")}</Typography.Title>
            <ObservationFilters />
          </>
        </TabPane>
        <TabPane number={2}>
          <>
            <Typography.Title level={4}>{t("piilotetutOtsikko")}</Typography.Title>
            <HiddenClashes />
          </>
        </TabPane>
        <ToolsTab number={3} />
        <ShareTab number={4} />
      </Tabs>
    </>
  )
}